export default __webpack_public_path__ + "static/media/objectives-lady.fd79a15a.svg";